import React, { useEffect, useState } from 'react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Upload } from 'lucide-react';
import api from '../../utils/api';
import { useTenant } from '../../context/TenantContext';
import { toast } from 'sonner';

const ClientDocuments = () => {
  const { activeTenant, onboardingStatus } = useTenant();
  const [documents, setDocuments] = useState([]);
  const isReadyToOperate = onboardingStatus?.is_ready_to_operate === true;

  useEffect(() => {
    if (activeTenant) {
      api.get(`/documents?tenant_id=${activeTenant}`).then(res => setDocuments(res.data));
    }
  }, [activeTenant]);

  const handleUpload = async (e) => {
    if (!isReadyToOperate) {
      toast.error('Cuenta en revision');
      return;
    }
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('tenant_id', activeTenant);
    try {
      await api.post('/documents/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success('Documento subido');
      api.get(`/documents?tenant_id=${activeTenant}`).then(res => setDocuments(res.data));
    } catch (error) {
      toast.error('Error subiendo documento');
    }
  };

  return (
    <div data-testid="client-documents-page" className="max-w-5xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-4xl font-heading font-bold">Documentos</h1>
        <div>
          <input type="file" id="client-file-upload" className="hidden" onChange={handleUpload} />
          <Button onClick={() => document.getElementById('client-file-upload').click()} className="gap-2" data-testid="upload-doc-button" disabled={!isReadyToOperate}>
            <Upload className="w-4 h-4" />Subir Documento
          </Button>
        </div>
      </div>
      <div className="space-y-4">
        {documents.map(doc => (
          <Card key={doc.id} className="hover:border-primary/50 hover:shadow-md transition-all">
            <CardContent className="p-6 flex items-center justify-between">
              <div>
                <h3 className="font-medium">{doc.filename}</h3>
                <p className="text-sm text-muted-foreground mt-1">{new Date(doc.created_at).toLocaleDateString()}</p>
              </div>
              <span className="text-sm text-muted-foreground">{doc.document_type}</span>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
export default ClientDocuments;
